/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import axios, { AxiosInstance } from 'axios';
import { getDefaultStore } from 'jotai';
import { activeSanctioningBodyIdAtom } from 'jotai/sanctioningBody';
import { SanctioningBodyEnum } from 'models/viewModels';
import { authService } from 'services/auth/AuthService';

export enum ApiRequestType {
  MotorsportsCompToolsApi,
  StreamMetricsApi,
  DataScienceRestApi,
  AlternativeEnvironmentApi,
}
const defaultStore = getDefaultStore();

const requestUrl: Record<SanctioningBodyEnum, Record<ApiRequestType, string>> = {
  [SanctioningBodyEnum.NASCAR]: {
    [ApiRequestType.MotorsportsCompToolsApi]: process.env.REACT_APP_COMPTOOLS_API_URL.toString(),
    [ApiRequestType.StreamMetricsApi]: process.env.REACT_APP_STREAM_METRICS_API_URL.toString(),
    [ApiRequestType.DataScienceRestApi]: process.env.REACT_APP_DS_API_REST_URL.toString(),
    [ApiRequestType.AlternativeEnvironmentApi]:
      process.env.REACT_APP_ALTERNATIVE_API_URL?.toString() || process.env.REACT_APP_COMPTOOLS_API_URL.toString(),
  },
  [SanctioningBodyEnum.INDYCAR]: {
    [ApiRequestType.MotorsportsCompToolsApi]: process.env.REACT_APP_COMPTOOLS_API_URL.toString(),
    [ApiRequestType.StreamMetricsApi]: process.env.REACT_APP_INDY_STREAM_METRICS_API_URL.toString(),
    [ApiRequestType.DataScienceRestApi]: process.env.REACT_APP_DS_API_REST_URL.toString(),
    [ApiRequestType.AlternativeEnvironmentApi]:
      process.env.REACT_APP_ALTERNATIVE_API_URL?.toString() || process.env.REACT_APP_COMPTOOLS_API_URL.toString(),
  },
  [SanctioningBodyEnum.IMSA]: {
    //TODO: Update when we support IMSA
    [ApiRequestType.MotorsportsCompToolsApi]: process.env.REACT_APP_COMPTOOLS_API_URL.toString(),
    [ApiRequestType.StreamMetricsApi]: process.env.REACT_APP_STREAM_METRICS_API_URL.toString(),
    [ApiRequestType.DataScienceRestApi]: process.env.REACT_APP_DS_API_REST_URL.toString(),
    [ApiRequestType.AlternativeEnvironmentApi]:
      process.env.REACT_APP_ALTERNATIVE_API_URL?.toString() || process.env.REACT_APP_COMPTOOLS_API_URL.toString(),
  },
  [SanctioningBodyEnum.F1]: {
    //TODO: Update when we support F1
    [ApiRequestType.MotorsportsCompToolsApi]: process.env.REACT_APP_COMPTOOLS_API_URL.toString(),
    [ApiRequestType.StreamMetricsApi]: process.env.REACT_APP_STREAM_METRICS_API_URL.toString(),
    [ApiRequestType.DataScienceRestApi]: process.env.REACT_APP_DS_API_REST_URL.toString(),
    [ApiRequestType.AlternativeEnvironmentApi]:
      process.env.REACT_APP_ALTERNATIVE_API_URL?.toString() || process.env.REACT_APP_COMPTOOLS_API_URL.toString(),
  },
  [SanctioningBodyEnum.UNKNOWN]: {
    [ApiRequestType.MotorsportsCompToolsApi]: process.env.REACT_APP_COMPTOOLS_API_URL.toString(),
    [ApiRequestType.StreamMetricsApi]: process.env.REACT_APP_STREAM_METRICS_API_URL.toString(),
    [ApiRequestType.DataScienceRestApi]: process.env.REACT_APP_DS_API_REST_URL.toString(),
    [ApiRequestType.AlternativeEnvironmentApi]:
      process.env.REACT_APP_ALTERNATIVE_API_URL?.toString() || process.env.REACT_APP_COMPTOOLS_API_URL.toString(),
  },
};

export const axiosConfig = (
  apiRequestType: ApiRequestType,
  sanctioningBody?: SanctioningBodyEnum,
  isBlob?: boolean
): AxiosInstance => {
  const storedSanctioningBody = defaultStore.get(activeSanctioningBodyIdAtom);
  const sanctioningBodyId = storedSanctioningBody ? storedSanctioningBody : SanctioningBodyEnum.UNKNOWN;
  return axios.create({
    baseURL: requestUrl[sanctioningBody ? sanctioningBody : sanctioningBodyId][apiRequestType],
    timeout: 60000,
    headers: {
      'Content-Type': 'application/json',
      Authorization: authService.getAuthorizationHeaderValue(),
    },
    ...(isBlob && { responseType: 'blob' }), // Required to response as blob
  });
};

export default axiosConfig;
